import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { AlertKeysEnum, type AlertKey } from "@tfg/types/constants/alerts"

export const useAlertMessage = (alertKey: AlertKey): string => {
  const { t } = useTranslation(["home"])

  const alertMessage = useMemo<string>(() => {
    switch (alertKey) {
      case AlertKeysEnum.AGEC_COMPLIANCE:
        return t("notifications.alerts.descriptions.agecCompliance")
      case AlertKeysEnum.DUPLICATE_PRODUCTION_SITES:
        return t("notifications.alerts.descriptions.duplicateProductionSites")
      case AlertKeysEnum.INCOMING_LAUNCH_DATE:
        return t("notifications.alerts.descriptions.incomingLaunchDate")
      case AlertKeysEnum.EXPIRED_LAUNCH_DATE:
        return t("notifications.alerts.descriptions.expiredLaunchDate")
      case AlertKeysEnum.EXPIRING_CERTIFICATES:
        return t("notifications.alerts.descriptions.expiringCertificates")
      default:
        return ""
    }
  }, [alertKey, t])

  return alertMessage
}
